import React, { useState, useEffect } from 'react';
import { message, Card, Statistic, Tooltip, Popover, Tag, Form, Modal, Row, Col, Input, Button, Skeleton, Table, Icon } from 'antd';
import { useMappedState, useDispatch } from 'redux-react-hook';
import { addOffer, getClients, getCandidates, getOffers } from './../API';
import CustomAvatar from './../components/customAvatar';
import { flexCenterRight } from './../theme';
import CreateOfferForm from './../forms/createOfferForm';
import moment from 'moment';
import { navigate } from "@reach/router"
import { s3 } from './../utils';
import { getCurrencySign } from '../utils/invoices';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

const { Search } = Input;
const { sumBy } = require('lodash');

function TheOffers({form}) {
  const dispatch = useDispatch();
  const session = useMappedState(state => state.session);
  const offers = useMappedState(state => state.offers);

  const [clients, setClients] = useState([]);
  const [candidates, setCandidates] = useState([]);

  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [openAddModal, setOpenAddModal] = useState(false);
  const [adding, setAdding] = useState(false);

  useEffect(() => {
    async function fetchData() {

      const dataResponse = await Promise.all([
        getClients(session.authToken),
        getCandidates(session.authToken),
        getOffers(session.authToken),
      ]);

      setClients(dataResponse[0].data.clients);
      setCandidates(dataResponse[1].data.candidates);
      dispatch({type: "INIT_OFFERS", payload: dataResponse[2].data.data});

      setLoading(false);
    }
    fetchData();
  // eslint-disable-next-line
  }, []);

  const columns = [
    {
      title: '',
      width: 35,
      fixed: 'left',
      key: 'indictor',
      render: (offer) => <div>
        {
          offer.invoice_docs ? (
            <Tooltip title="Click To Invoice">
              <div
                style={{cursor: "pointer"}}
                onClick={() => {
                  navigate(`/invoices/${offer.invoice_docs.id}`);
                }}
              >
                {
                  offer.invoice_docs.isActive ? (
                    <FontAwesomeIcon icon={faFileInvoiceDollar} style={{ fontSize: '16px', color: '#8DB600' }}/>
                  ) : (
                    <FontAwesomeIcon icon={faFileInvoiceDollar} style={{ fontSize: '16px', color: '#CB4154' }}/>
                  )
                }
              </div>
            </Tooltip>
          ) : (
            <div>
              {
                offer.flag ? (
                  <Tooltip title={offer.flag}>
                    <FontAwesomeIcon icon={faExclamationTriangle} style={{ fontSize: '16px', color: '#DE5D83' }}/>                  
                  </Tooltip>
                ) : null
              }
            </div>
          )
        }
      </div>
    },
    {
      title: 'Client',
      width: 250,
      fixed: 'left',
      key: 'client',
      render: (offer) => <div style={{cursor: "pointer"}} onClick={() => {
        navigate(`/clients/${offer.client_docs.id}`)
      }}>
        <CustomAvatar
          colourCode={offer.client_docs.name.charAt(0).toLowerCase()}
          char={`${offer.client_docs.name.charAt(0).toUpperCase()}`}
          charSize={13}
          size={26}
          src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/client/${offer.client_docs.id}.jpeg`}
        />
        &nbsp;{offer.client_docs.name}
      </div>
    },
    {
      title: 'Position',
      width: '10%',
      dataIndex: 'position',
      key: 'position',
    },
    {
      title: 'Service',
      width: '10%',
      dataIndex: 'service',
      key: 'service',
    },
    {
      title: 'Currency',
      width: '8%',
      dataIndex: 'currency',
      key: 'currency',
    },
    {
      title: 'Salary',
      width: '8%',
      render: (offer) => <div>
        <b><Tag color="#B0BF1A">{getCurrencySign(offer.currency)} {offer.salary.toLocaleString()}</Tag></b>
      </div>
    },
    {
      title: 'Sign On Bonus',
      width: '8%',
      dataIndex: 'signOnBonus',
      key: 'signOnBonus',
    },
    {
      title: 'Bonus',
      width: '10%',
      dataIndex: 'bonus',
      key: 'bonus',
    },
    {
      title: 'Relocation Allowance',
      width: '16%',
      dataIndex: 'relocationAllowance',
      key: 'relocationAllowance',
    },
    {
      title: 'Location',
      width: '10%',
      dataIndex: 'location',
      key: 'location',
    },
    {
      title: "",
      width: '5%',
      render: (offer) => <div>        
        <center>
          <Popover 
            overlayStyle={{
              width: '35vw',
            }}
            placement="top" 
            content={offer.note ? offer.note : <div style={{color: '#ccc'}}>Not Available</div>} 
            title="Notes"
          >
            <FontAwesomeIcon icon={faExclamationCircle} />
          </Popover>
        </center>  
      </div>
    },
    {
      title: 'Candidate',
      width: '14%',
      key: 'candidate',
      render: (offer) => <div style={{cursor: "pointer"}} onClick={() => {
        navigate(`/candidates/${offer.candidate_docs.id}`)
      }}>
        <CustomAvatar
          colourCode={offer.candidate_docs.firstname.charAt(0).toLowerCase()}
          char={`${offer.candidate_docs.firstname.charAt(0).toUpperCase()}${offer.candidate_docs.lastname.charAt(0).toUpperCase()}`}
          charSize={13}
          size={26}
          src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/candidate/${offer.candidate_docs.id}.jpeg`}
        />
        &nbsp;{offer.candidate_docs.firstname} {offer.candidate_docs.lastname}
      </div>
    },
    {
      title: 'On Board',
      width: '10%',
      key: 'onBoardDate',
      render: (offer) => <>
        {
          offer.onBoardDate ? (
            <div>{moment(offer.onBoardDate).format('YYYY-MM-DD')}</div>
          ) : (
            <div style={{ color: '#cccccc' }}>Not Available</div>
          )
        }
      </>
    }
  ];

  const renderCard = (color, number, text, prefix, suffix) => {
    return (
      <Card size="small" style={{ marginLeft: '5px', marginRight: '5px', backgroundColor: color }}>
        {
          prefix ? (
            <Statistic title="" valueStyle={{ fontSize: '28px', color: '#fff' }} value={number} prefix={prefix} suffix={suffix} />
          ) : (
            <Statistic title="" valueStyle={{ fontSize: '28px', color: '#fff' }} value={number} suffix={suffix} />
          )
        }
        <Row>
          <Col span={18}>
            <div style={{ color: 'white' }}>{text}</div>
          </Col>
          <Col span={6}>
            <div style={flexCenterRight}>
              <FontAwesomeIcon
                style={{
                  cursor: 'pointer',
                  marginTop: '5px',
                  fontSize: '14px',
                  color: 'white'
                }} icon={faInfoCircle} />
            </div>
          </Col>
        </Row>
      </Card>
    )
  }

  const calculateAverage = (total, length) => {
    const isInt = (n) => {
      return Number(n) === n && n % 1 === 0;
    }

    const result = total/length;
    if (isInt(result)) {
      return result;
    }
    return `${result.toFixed(2).toLocaleString()}`;
  }

  const offersData = search === "" ? offers : 
    offers.filter(i =>
      i.client_docs.name.toLowerCase().includes(search.toLowerCase()) ||
      i.location.toLowerCase().includes(search.toLowerCase()) ||
      i.position.toLowerCase().includes(search.toLowerCase()) ||
      i.service.toLowerCase().includes(search.toLowerCase())
    )

  const gbp = offersData.filter((i) => i.currency === 'GBP');
  const sgd = offersData.filter((i) => i.currency === 'SGD');
  const hkd = offersData.filter((i) => i.currency === 'HKD');

  const gbpTotal = sumBy(gbp, 'salary');
  const sgdTotal = sumBy(sgd, 'salary');
  const hkdTotal = sumBy(hkd, 'salary');
  
  const gbpAverage = calculateAverage(gbpTotal, gbp.length);
  const sgdAverage = calculateAverage(sgdTotal, sgd.length);
  const hkdAverage = calculateAverage(hkdTotal, hkd.length);

  return (
    loading ?
    <div>
      <p>Loading...</p>
      <Skeleton active />
    </div>
    :
    <div>
      <Modal
        centered={true}
        title="Create New Offer"
        closable={false}
        visible={openAddModal}
        width="96%"
        footer={[
          <Button key="cancel" onClick={() => {
            setOpenAddModal(false);
            form.resetFields();
          }}>
            <Icon type="close" />
            Cancel
          </Button>,
          <Button key="create" type="primary" onClick={async () => {
            const formResult = await form.validateFields();
            
            setAdding(true);
            let param = {
              client: formResult.client,
              candidate: formResult.candidate,
              location: formResult.location,
              position: formResult.position,
              service: formResult.service,
              currency: formResult.currency,
              salary: formResult.salary,
              signOnBonus: formResult.signOnBonus,
              bonus: formResult.bonus ? formResult.bonus : '',
              relocationAllowance: formResult.relocationAllowance ? formResult.relocationAllowance : '',
              note: formResult.note ? formResult.note : '',
            };

            if (formResult.onBoard) {
              param = {
                ...param,
                ...{
                  onBoardDate: `${moment(formResult.onBoard).format('YYYY-MM-DD')} 09:00:00`,
                }
              }
            }

            const result = await addOffer(session.authToken, param);

            if (result.data.responseCode === 0) {
              const response = await getOffers(session.authToken);
              dispatch({type: "INIT_OFFERS", payload: response.data.data});
        
              setOpenAddModal(false);
              setAdding(false);
              form.resetFields();
              message.success(result.data.message);
            }
            else {
              setAdding(false);
              message.error(result.data.message.toString());
            }

          }}>
            {adding ? <Icon type="loading" /> : <Icon type="check" />}
            Create
          </Button>
        ]}
      >
        <div>
          <CreateOfferForm
            form={form}
            submitting={adding}
            clients={clients}
            candidates={candidates}
          /> 
        </div>
      </Modal>

      <Row>
        <Col span={6}>
          {renderCard('#B0BF1A', offersData.length, 'Total Offers', null, ` / ${offersData.filter((i) => i.invoice_docs).length} invoices`)}
        </Col>

        {
          gbp.length > 0 ? (
            <Col span={6}>
              {renderCard('#B284BE', gbpAverage, 'Average GBP Salary', '£', ` / ${gbp.length} offers`)}
            </Col>
          ) : null
        }

        {
          sgd.length > 0 ? (
            <Col span={6}>
              {renderCard('#72A0C1', sgdAverage, 'Average SGD Salary', 'S$', `/ ${sgd.length} offers`)}
            </Col>
          ) : null
        }
        
        {
          hkd.length > 0 ? (
            <Col span={6}>
              {renderCard('#DE5D83', hkdAverage, 'Average HKD Salary', 'HK$', `/ ${hkd.length} offers`)}
            </Col>
          ) : null
        }
      </Row> 

      <br />
      <Row>
        <Col span={12}>
          <Search
            placeholder="Search"
            onChange={e => setSearch(e.target.value)}
            style={{ width: 200 }}
          />
        </Col>
        <Col span={12}>
          <div style={flexCenterRight}>
            <Button type="primary" onClick={() => {
              setOpenAddModal(true);
            }}><Icon type="plus-square" /> New Offer</Button>
          </div>
        </Col>
      </Row>

      <br/>
      <Table
        pagination={{ pageSize: 50}}
        columns={columns}
        dataSource={offersData}
        rowKey="id"
        scroll={{ x: 2100 }}
      />
    </div>
  )
}

const Offers = Form.create({ name: 'offers' })(TheOffers);
export default Offers;